export default __webpack_public_path__ + "static/media/prada.4d4ef86e.jpg";